/* eslint-disable camelcase */
import { Component } from 'react';
import { connect } from 'react-redux';
import SiteLoader from '../layout/site-loader';
import PageTitle from '../common/page-title/index';
import HomePageCarousel from '../common/home/user-home-page-carousel';
import PpcCarousel from '../common/home/carousels/ppc-carousel';
import TradeCarousel from '../common/home/carousels/trade-carousel';
import BrandCarousel from '../common/home/carousels/brand-carousel';
import EverythingElseCarousel from '../common/home/carousels/everything-else-carousel';
import { getHomePage } from '../../actions/home';
import { getLatestNews } from '../../actions/latest-news';
import { getBluBarBrands, getHomePageBrands } from '../../actions/brands-user';
import BluBarCarousel from '../common/home/carousels/blu-bar-carousel';

import './styles.css';

class HomePage extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getHomePage());
    dispatch(getLatestNews());
    dispatch(getHomePageBrands());
    dispatch(getBluBarBrands());
  }

  render() {
    const {
      profileLoaded, carousels, loading, carouselSpeed
    } = this.props;

    if (!profileLoaded || loading) {
      return <SiteLoader/>;
    }

    return (
      <div className='user-home-page'>
        <PageTitle pageTitle='Home'/>
        {profileLoaded && (
          <div>
            <div className="home-slide user-home-page-slide user-inner-container">
              <HomePageCarousel carousels={carousels} carouselSpeed={carouselSpeed} isRedButton />
            </div>
            <div className="home-page-spacer ppc-carousel">
              <PpcCarousel />
            </div>
            <div className="home-page-spacer">
              <TradeCarousel />
            </div>
            <div className="home-page-spacer">
              <BrandCarousel />
            </div>
            <div className="home-page-spacer">
              <BluBarCarousel />
            </div>
            <div className="home-page-spacer">
              <EverythingElseCarousel />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  showPersonalRewardsSettings: state.viewConfig.showPersonalRewardsSettings,
  profile: state.viewConfig.profile,
  profileLoaded: state.viewConfig.loaded,
  carousels: state.home.home_carousels,
  loading: state.home.fetching && !state.home.fetched,
  carouselSpeed: state.home.carousel_speed,
});

export default connect(mapStateToProps)(HomePage);
